import React, { useRef, useState } from 'react';
import { Mark } from '../Logo';
import Barras from './Barras';
import {
  AREAS_DO_CANAL,
  AREAS_DO_PAINEL,
  CANAL,
  COLUNAS_DA_PLANILHA,
  CORRECOES,
  EXECUCAO,
  NOTA,
  NOTA_DO_CANAL,
  PESOS,
  PESOS_DO_CANAL,
  PLANILHA,
  ROTULO_DA_AREA,
  decimalEm,
  perdaDe
} from './amostra';
import { LIMIARES as LIMIARES_DO_CANAL } from '../../utils/youtubeMetrics';
import { useIdioma } from '../../i18n';
import { useFormato } from '../../i18n/formato';
import '../../styles/Saidas.css';

const SAIDAS = ['relatorio', 'correcoes', 'naSuaIa', 'planilha', 'canal'];
const categoria = (area) => `otim.cat${area[0].toUpperCase()}${area.slice(1)}`;

/* Tom de cada célula da planilha, pelos mesmos limiares do painel. */
const TOM_DA_CELULA = [
  null,
  (v) => (v >= 400 ? 'nh-crit' : null),
  (v) => (v > 60 ? 'nh-warn' : null),
  (v) => (v === 0 ? 'nh-crit' : null),
  (v) => (v === 0 ? 'nh-crit' : null),
  (v) => (v >= 5000 ? 'nh-crit' : v >= 3000 ? 'nh-warn' : null),
  (v) => (v > 0 ? 'nh-crit' : null)
];

const Relatorio = ({ t, numero, data, decimal }) => {
  /* O total é a soma das linhas como aparecem, para a conta fechar a olho. */
  const perdas = AREAS_DO_PAINEL.map((area) => Math.round(perdaDe(area, EXECUCAO.afetadas[area]) * 100) / 100);
  const soma = perdas.reduce((a, b) => a + b, 0);
  return (
    <div className="saidas-papel" data-ui>
      <div className="saidas-papel-topo">
        <Mark size={34} variant="ink" />
        <span>{data(EXECUCAO.data, { day: 'numeric', month: 'long', year: 'numeric' })}</span>
      </div>
      <p className="saidas-papel-titulo">{t('inicio.saidas.relTitulo')}</p>
      <p className="saidas-papel-meta">
        {t('inicio.saidas.relMeta', {
          site: EXECUCAO.site,
          n: EXECUCAO.numero,
          paginas: t('otim.paginas', { n: numero(EXECUCAO.total), quantidade: EXECUCAO.total })
        })}
      </p>
      <p className="saidas-papel-nota">
        <b>{NOTA}</b> <span>{t('inicio.tela.deCem')}</span>
      </p>
      <p className="saidas-papel-secao">{t('inicio.saidas.resumo')}</p>
      <p>
        {t('inicio.saidas.relResumo', {
          pct: Math.round((EXECUCAO.status['2xx'] / EXECUCAO.total) * 100),
          n: numero(EXECUCAO.semDescricao)
        })}
      </p>
      <p className="saidas-papel-secao">{t('inicio.saidas.deOndeSairam')}</p>
      <table>
        <thead>
          <tr>
            <th>{t('inicio.saidas.colArea')}</th>
            <th className="n">{t('inicio.saidas.colPeso')}</th>
            <th className="n">{t('inicio.saidas.colPaginas')}</th>
            <th className="n">{t('inicio.saidas.colPerdidos')}</th>
          </tr>
        </thead>
        <tbody>
          {AREAS_DO_PAINEL.map((area, i) => (
            <tr key={area}>
              <td>{t(ROTULO_DA_AREA[area])}</td>
              <td className="n">{PESOS[area]}</td>
              <td className="n">{numero(EXECUCAO.afetadas[area])}</td>
              <td className="n">−{decimal(perdas[i])}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td>{t('inicio.saidas.total')}</td>
            <td className="n">100</td>
            <td className="n">{numero(EXECUCAO.total)}</td>
            <td className="n">−{decimal(soma)}</td>
          </tr>
        </tfoot>
      </table>
      <p className="saidas-papel-secao">{t('inicio.saidas.prioridades')}</p>
      <ol>
        {CORRECOES.slice(0, 3).map((c) => (
          <li key={c.chave}>{t(`inicio.saidas.${c.chave}`)}</li>
        ))}
      </ol>
    </div>
  );
};

const Correcoes = ({ t, numero }) => (
  <div className="saidas-app" data-ui>
    <p className="saidas-app-titulo">{t('inicio.saidas.iaTitulo')}</p>
    <p className="nh-soft saidas-app-meta">{t('inicio.saidas.iaMeta', { custo: t('otim.custo', { n: 1 }) })}</p>
    <p className="saidas-app-resumo">{t('inicio.saidas.iaResumo')}</p>
    {CORRECOES.map((c) => (
      <div className="saidas-correcao" key={c.chave}>
        <p>{t(`inicio.saidas.${c.chave}`)}</p>
        <div className="saidas-etiquetas">
          <span className="is-forte">{t('otim.impacto', { nivel: t(`otim.nivel${c.impacto}`) })}</span>
          <span>{t('otim.esforco', { nivel: t(`otim.nivel${c.esforco}`) })}</span>
          <span>{t(categoria(c.area))}</span>
          <span className="nh-num">{t('otim.paginas', { n: numero(c.paginas), quantidade: c.paginas })}</span>
        </div>
      </div>
    ))}
  </div>
);

const NaSuaIa = ({ t }) => (
  <div className="saidas-conversa" data-ui>
    <div className="saidas-fala is-sua">{t('inicio.saidas.mcpPergunta')}</div>
    <div className="saidas-ferramenta">
      <span className="nh-ponto nh-ok" />
      {t('inicio.saidas.mcpConsultou')} <code>get_run_data</code> · {t('inicio.saidas.mcpExecucao', { n: EXECUCAO.numero })}
    </div>
    <div className="saidas-fala">
      {t('inicio.saidas.mcpResposta1', { n: EXECUCAO.linksQuebrados })}
      <ul>
        {['/promocao-verao', '/blog/guia-2023', '/trocas'].map((c) => (
          <li key={c}><code>{c}</code></li>
        ))}
      </ul>
      {t('inicio.saidas.mcpResposta2', { n: EXECUCAO.linksQuebrados, m: EXECUCAO.semLinkInterno })}
    </div>
    <p className="nh-soft saidas-rodape">{t('inicio.saidas.mcpRodape')}</p>
  </div>
);

const Planilha = ({ numero }) => (
  <div className="saidas-planilha" data-ui>
    <table>
      <thead>
        <tr>
          {COLUNAS_DA_PLANILHA.map((c) => (
            <th key={c}><code>{c}</code></th>
          ))}
        </tr>
      </thead>
      <tbody>
        {PLANILHA.map((linha) => (
          <tr key={linha[0]}>
            {linha.map((valor, i) =>
              i === 0 ? (
                <td key={i}><code>{valor}</code></td>
              ) : (
                <td key={i} className={`n ${TOM_DA_CELULA[i](valor) || ''}`.trim()}>{numero(valor)}</td>
              )
            )}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const Canal = ({ t, numero, decimal, locale }) => {
  const perdas = Object.fromEntries(
    AREAS_DO_CANAL.map((area) => [area, (PESOS_DO_CANAL[area] * CANAL.afetados[area]) / CANAL.videos])
  );
  const videos = [
    { chave: 'video1', views: 18420, tom: 'nh-warn', aviso: t('inicio.saidas.tituloAcima', { n: 64, max: LIMIARES_DO_CANAL.TITULO_MAX }) },
    {
      chave: 'video2',
      views: 9877,
      tom: 'nh-crit',
      aviso: t('inicio.saidas.engajamentoAbaixo', { n: decimalEm(locale, 1)(1.4), min: LIMIARES_DO_CANAL.ENGAJAMENTO_BOM })
    },
    { chave: 'video3', views: 3102, tom: 'nh-warn', aviso: t('inicio.saidas.descricaoCurta', { min: LIMIARES_DO_CANAL.DESCRICAO_MIN }) }
  ];
  return (
    <div className="saidas-app saidas-canal" data-ui>
      <p className="saidas-app-titulo">{CANAL.nome}</p>
      <p className="nh-soft saidas-app-meta">
        {t('inicio.saidas.canalMeta', { videos: numero(CANAL.videos), n: CANAL.execucao })}
      </p>
      <div className="nh-nota saidas-canal-nota">
        <b>{NOTA_DO_CANAL}</b>
        <span>{t('inicio.tela.deCem')}</span>
      </div>
      <Barras
        areas={AREAS_DO_CANAL}
        pesos={PESOS_DO_CANAL}
        perdas={perdas}
        rotulo={(area) => t(categoria(area))}
        decimal={decimal}
      />
      {videos.map((v) => (
        <div className="saidas-video" key={v.chave}>
          <span>{t(`inicio.saidas.${v.chave}`)}</span>
          <span className="nh-num">{numero(v.views)}</span>
          <em className={v.tom}>{v.aviso}</em>
        </div>
      ))}
    </div>
  );
};

/**
 * "O que sai de cada execução": os nomes são abas, e o palco ao lado mostra a
 * saída escolhida como ela é no produto (relatório, lista da IA, resposta na IA
 * do cliente pelo conector, planilha e painel do canal).
 */
const Saidas = () => {
  const { t } = useIdioma();
  const { numero, data, locale } = useFormato();
  const decimal = decimalEm(locale);
  const [ativa, setAtiva] = useState(SAIDAS[0]);
  const abas = useRef({});

  const teclar = (e, i) => {
    const passo = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[e.key];
    if (!passo) return;
    e.preventDefault();
    const proxima = SAIDAS[(i + passo + SAIDAS.length) % SAIDAS.length];
    setAtiva(proxima);
    abas.current[proxima]?.focus();
  };

  const folhas = {
    relatorio: <Relatorio t={t} numero={numero} data={data} decimal={decimal} />,
    correcoes: <Correcoes t={t} numero={numero} />,
    naSuaIa: <NaSuaIa t={t} />,
    planilha: <Planilha numero={numero} />,
    canal: <Canal t={t} numero={numero} decimal={decimal} locale={locale} />
  };

  return (
    <section className="saidas" id="saidas" aria-labelledby="saidas-titulo">
      <div className="nh-grade">
        <div className="saidas-indice">
          <h2 id="saidas-titulo" data-r>{t('inicio.saidas.titulo')}</h2>
          <div className="saidas-nomes" role="tablist" aria-label={t('inicio.saidas.titulo')}>
            {SAIDAS.map((s, i) => (
              <button
                key={s}
                type="button"
                role="tab"
                id={`saida-${s}`}
                aria-selected={ativa === s}
                aria-controls={`folha-${s}`}
                tabIndex={ativa === s ? 0 : -1}
                ref={(el) => (abas.current[s] = el)}
                onClick={() => setAtiva(s)}
                onKeyDown={(e) => teclar(e, i)}
              >
                {t(`inicio.saidas.nome.${s}`)}
              </button>
            ))}
          </div>
          <p className="saidas-legenda">{t(`inicio.saidas.legenda.${ativa}`, PESOS_DO_CANAL)}</p>
        </div>

        <div className="saidas-palco" data-r style={{ '--i': 1 }}>
          {SAIDAS.map((s) => (
            <div
              key={s}
              className={`saidas-folha saidas-folha-${s} ${ativa === s ? 'is-on' : ''}`.trim()}
              id={`folha-${s}`}
              role="tabpanel"
              aria-labelledby={`saida-${s}`}
              hidden={ativa !== s}
            >
              {folhas[s]}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Saidas;
